import { useEffect, useRef, useState } from 'react'
import { EventEmitter } from 'events'
import MessageBox from './Prompt'

const eventsBus = new EventEmitter()
const OPEN_PROMPT = 'OPEN_PROMPT'

export const openPrompt = (props: any) => eventsBus.emit(OPEN_PROMPT, props)

const PromptContainer = () => {
  const [promptList, setPromptList] = useState<any>([])
  const promptListRef = useRef<any>([])
  // countId 用于标识Prompt，遍历时不会重新更新，之后updateDep也可以基于countId，更新Prompt
  const countIdRef = useRef<number>(0)
  promptListRef.current = promptList
  useEffect(() => {
    const removePrompt = () => {
      promptListRef.current.splice(
        -1,
        1,
      )
      setPromptList(promptListRef.current)
    }
    eventsBus.on(OPEN_PROMPT, (props: any) => {
      // eslint-disable-next-line no-plusplus
      countIdRef.current++
      const currentCountId = countIdRef.current
      setPromptList([
        ...promptListRef.current,
        {
          ...props,
          countId: currentCountId,
          onClose: () => {
            // @ts-ignore
            props?.onClose?.(...arguments)
            removePrompt()
          },
          onConfirm: async (preventHandler: () => void) => {
            // 使用 e.preventDefault 类似的设计时，二次封装需要对入参也进行二次封装
            let flag = false
            const propsPreventHandler = () => {
              flag = true
              preventHandler()
            }
            // @ts-ignore
            await props?.onConfirm?.(propsPreventHandler)
            if (flag) return
            removePrompt()
          },
        },
      ])
    })
  }, [])
  return (
    <>
      {promptList.map((prompt: any) => (
        <MessageBox {...prompt} key={prompt.countId} />
      ))}
    </>
  )
}

export default PromptContainer
